import {HttpClient} from '@sollapay/http-client';

const SCRIPT_TAG_PATTERN = /<script\b[^>]*>/gi;
const MODULE_TYPE_PATTERN = /\btype=["']module["']/i;
const SRC_PATTERN = /\ssrc=["']([^"']+)["']/i;

const indexClient = new HttpClient({baseUrl: ''});

export function extractEntryScriptSrc(html: string): string | undefined {
  for (const [tag] of html.matchAll(SCRIPT_TAG_PATTERN)) {
    const src = MODULE_TYPE_PATTERN.test(tag) ? SRC_PATTERN.exec(tag)?.[1] : undefined;
    if (src) return src;
  }
  return undefined;
}

export function getCurrentEntryScriptSrc(): string | undefined {
  return (
    document.querySelector<HTMLScriptElement>('script[type="module"][src]')?.getAttribute('src') ??
    undefined
  );
}

export async function fetchLatestEntryScriptSrc(): Promise<string | undefined> {
  try {
    const html = await indexClient.get<unknown>('/index.html', {
      headers: {'Cache-Control': 'no-cache'}
    });
    return typeof html === 'string' ? extractEntryScriptSrc(html) : undefined;
  } catch {
    return undefined;
  }
}
